import {createContext} from 'react';
import { EAccountStatus } from '../../common/enum/EAccountStatus';

export const authContext = createContext({loggedIn:false, status:EAccountStatus.NotMentioned,setAuthData:(data:any)=>{}});

